module.exports = __webpack_public_path__ + "static/img/picture23.e640d37c.png";